export default "__VITE_ASSET__DYCeqlS___"